import React, { useState } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../constants/colors';
import { axiosPath } from '../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import AppSpinner from '../../../../../components/AppSpinner';
import Translator from '../../../../../components/helpers/Translator';
import errorHandler from '../../../../../components/error/ErrorHandler';

const UserMark = (props) => {
  const {
    plantObligationID, isMouseOver,
  } = props;
  const dispatch = useDispatch();
  const { moduleBridgeHex, plantHex } = useParams();
  const userMarkPoID = useSelector((state) => state.currentPage?.options?.userMark);
  const [isLoading, setIsLoading] = useState(false);

  // > SET USERMARK
  const changeFavourite = async (poID) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_evaluation_setUserMarkObligation"
        ),
        { moduleBridgeHex, plantHex, plantObligationID: poID }
      );
      setIsLoading(false);
      dispatch(currentPageAction.change('options', { userMark: response.data || null }));
    } catch (err) {
      setIsLoading(false);
      dispatch(errorHandler(err, history));
    }
  };
  // < SET USERMARK

  if (isLoading) {
    return (
      <AppSpinner>
        <AppRemixIcon
          icon="loader-4"
          color={colors.primary}
          size={24}
        />
      </AppSpinner>
    );
  }

  return (
    <>
      {userMarkPoID === plantObligationID ? (
        <AppRemixIcon
          title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="obligation.unmark.position" />)}
          className="pointer"
          color={colors.danger}
          icon="map-pin-user"
          size={24}
          onClick={() => changeFavourite(null)}
        />
      ) : (
        <>
          {isMouseOver && (
            <AppRemixIcon
              title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="obligation.mark.position" />)}
              className="pointer"
              color={colors.grey400}
              icon="map-pin-user"
              size={24}
              onClick={() => changeFavourite(plantObligationID)}
            />
          )}
        </>
      )}
    </>
  );
};

export default UserMark;
